module.exports = __webpack_public_path__ + "static/media/ic_camera_switch.23bc4143.svg";